import { useCallback, useEffect, useState } from 'react';
import Modal from 'react-modal';
import cn from 'classnames';

import { evSearchCrossSiteRecoClick, evSearchCrossSiteRecoImpression } from 'events/recommendations';
import { track } from 'apis/amethyst';
import useMartyContext from 'hooks/useMartyContext';
import MelodyCardTwoCol from 'components/common/melodyCard/MelodyCardTwoCol';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';

import modalCSS from 'styles/components/common/modal.scss';
import css from 'styles/components/search/crossSiteProducts.scss';

export const CrossSiteProducts = ({ trustedRetailers = [], ProductComponent, additionalClasses, msaImageParams, hydraSearchColorSwatches }) => {
  const { testId, marketplace: { shortName } } = useMartyContext();
  const [modal, setModal] = useState(null);

  const handleClickCard = useCallback((productObj, index, e) => {
    e.preventDefault();
    const product = { ...productObj, index };
    track(() => ([
      evSearchCrossSiteRecoClick, { product }
    ]));
    setModal(product);
  }, []);

  const handleClickStay = useCallback(product => {
    track(() => ([
      evSearchCrossSiteRecoClick, { product, proceedToTrustedRetailer: false }
    ]));
    setModal(null);
  }, []);

  const handleClickContinue = useCallback(product => {
    track(() => ([
      evSearchCrossSiteRecoClick, { product, proceedToTrustedRetailer: true }
    ]));
    setModal(null);
  }, []);

  useEffect(() => {
    track(() => ([evSearchCrossSiteRecoImpression, trustedRetailers]));
  }, [trustedRetailers]);

  if (trustedRetailers.length) {
    return (
      <>
        {trustedRetailers.map((v, i) => (
          <ProductComponent
            key={`${v.styleId}-${v.store}`}
            componentStyle="searchProductCrossSite"
            crossSite={v.store}
            onComponentClick={e => handleClickCard(v, i, e)}
            additionalClasses={additionalClasses}
            hydraSearchColorSwatches={hydraSearchColorSwatches}
            cardData={v}
            index={i}
            msaImageParams={msaImageParams}
            melodyCardTestId={testId('searchResultsCrossSiteProduct')}
            showRatingStars={false}
            shouldLazyLoad={false}/>
        ))}
        {!!modal && <Modal
          onRequestClose={() => handleClickStay(modal)}
          className={cn(modalCSS.modalContent, css.modal)}
          overlayClassName={cn(modalCSS.modalOverlay, css.modalOverlay)}
          isOpen={!!modal}>
          <div className={modalCSS.header}>
            <h2>You are about to leave {shortName}</h2>
            <button
              type="button"
              className={modalCSS.close}
              onClick={() => handleClickStay(modal)}
              aria-label="Close"/>
          </div>
          <div className={css.modalContent}>
            <p className={css.copy}>
              You are being redirected to our trusted retailer, <a href={modal.storeUrl}>{`${modal.store}.com`}</a>, because {shortName}.com does not carry this product.
            </p>
            <MelodyCardTwoCol {...modal} noLink={true} />
          </div>
          <div className={css.modalBtnContainer}>
            <button
              data-test-id={testId('searchResultsCrossSiteModalStay')}
              type="button"
              className={css.btnStay}
              onClick={() => handleClickStay(modal)}>
              Stay on {shortName}
            </button>
            <a
              onClick={() => handleClickContinue(modal)}
              data-test-id={testId('searchResultsCrossSiteModalContinue')}
              className={css.btnContinue}
              href={modal.productSeoUrl}
              target="_blank"
              rel="noopener noreferrer">
              Continue to {modal.store}
            </a>
          </div>
        </Modal>}
      </>
    );
  }

  return null;
};

export default withErrorBoundary('CrossSiteProducts', CrossSiteProducts);
